import { IconProps } from "./";
import Icon from "./assets/help_info_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24HelpInfo(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
